import type { AssignmentActions } from "@school-sales-ai/shared";

/** True when `assignmentActionsFor` grants this user anything to click. */
export function hasAssignmentActions(actions: AssignmentActions): boolean {
  return actions.canAssignAny || actions.canClaim || actions.canRelease || actions.canTransfer;
}
